// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { AtBatEventDataWire, AtBatEventDataWireT } from '../mannequin/at-bat-event-data-wire';
import { BattingOrderEventDataWire, BattingOrderEventDataWireT } from '../mannequin/batting-order-event-data-wire';
import { CountEventDataWire, CountEventDataWireT } from '../mannequin/count-event-data-wire';
import { GumboTimecodeEventDataWire, GumboTimecodeEventDataWireT } from '../mannequin/gumbo-timecode-event-data-wire';
import { HandedEventDataWire, HandedEventDataWireT } from '../mannequin/handed-event-data-wire';
import { InningEventDataWire, InningEventDataWireT } from '../mannequin/inning-event-data-wire';
import { LiveActionEventDataWire, LiveActionEventDataWireT } from '../mannequin/live-action-event-data-wire';
import { PlayEventDataWire, PlayEventDataWireT } from '../mannequin/play-event-data-wire';
import { PositionAssignmentEventDataWire, PositionAssignmentEventDataWireT } from '../mannequin/position-assignment-event-data-wire';
import { TeamScoreEventDataWire, TeamScoreEventDataWireT } from '../mannequin/team-score-event-data-wire';


export enum GameEventDataWire {
  NONE = 0,
  CountEventDataWire = 1,
  TeamScoreEventDataWire = 2,
  BattingOrderEventDataWire = 3,
  LiveActionEventDataWire = 4,
  InningEventDataWire = 5,
  AtBatEventDataWire = 6,
  PlayEventDataWire = 7,
  HandedEventDataWire = 8,
  PositionAssignmentEventDataWire = 9,
  GumboTimecodeEventDataWire = 10
}

export function unionToGameEventDataWire(
  type: GameEventDataWire,
  accessor: (obj:AtBatEventDataWire|BattingOrderEventDataWire|CountEventDataWire|GumboTimecodeEventDataWire|HandedEventDataWire|InningEventDataWire|LiveActionEventDataWire|PlayEventDataWire|PositionAssignmentEventDataWire|TeamScoreEventDataWire) => AtBatEventDataWire|BattingOrderEventDataWire|CountEventDataWire|GumboTimecodeEventDataWire|HandedEventDataWire|InningEventDataWire|LiveActionEventDataWire|PlayEventDataWire|PositionAssignmentEventDataWire|TeamScoreEventDataWire|null
): AtBatEventDataWire|BattingOrderEventDataWire|CountEventDataWire|GumboTimecodeEventDataWire|HandedEventDataWire|InningEventDataWire|LiveActionEventDataWire|PlayEventDataWire|PositionAssignmentEventDataWire|TeamScoreEventDataWire|null {
  switch(GameEventDataWire[type]) {
    case 'NONE': return null; 
    case 'CountEventDataWire': return accessor(new CountEventDataWire())! as CountEventDataWire;
    case 'TeamScoreEventDataWire': return accessor(new TeamScoreEventDataWire())! as TeamScoreEventDataWire;
    case 'BattingOrderEventDataWire': return accessor(new BattingOrderEventDataWire())! as BattingOrderEventDataWire;
    case 'LiveActionEventDataWire': return accessor(new LiveActionEventDataWire())! as LiveActionEventDataWire;
    case 'InningEventDataWire': return accessor(new InningEventDataWire())! as InningEventDataWire;
    case 'AtBatEventDataWire': return accessor(new AtBatEventDataWire())! as AtBatEventDataWire;
    case 'PlayEventDataWire': return accessor(new PlayEventDataWire())! as PlayEventDataWire;
    case 'HandedEventDataWire': return accessor(new HandedEventDataWire())! as HandedEventDataWire;
    case 'PositionAssignmentEventDataWire': return accessor(new PositionAssignmentEventDataWire())! as PositionAssignmentEventDataWire;
    case 'GumboTimecodeEventDataWire': return accessor(new GumboTimecodeEventDataWire())! as GumboTimecodeEventDataWire;
    default: return null;
  }
}

export function unionListToGameEventDataWire(
  type: GameEventDataWire, 
  accessor: (index: number, obj:AtBatEventDataWire|BattingOrderEventDataWire|CountEventDataWire|GumboTimecodeEventDataWire|HandedEventDataWire|InningEventDataWire|LiveActionEventDataWire|PlayEventDataWire|PositionAssignmentEventDataWire|TeamScoreEventDataWire) => AtBatEventDataWire|BattingOrderEventDataWire|CountEventDataWire|GumboTimecodeEventDataWire|HandedEventDataWire|InningEventDataWire|LiveActionEventDataWire|PlayEventDataWire|PositionAssignmentEventDataWire|TeamScoreEventDataWire|null, 
  index: number
): AtBatEventDataWire|BattingOrderEventDataWire|CountEventDataWire|GumboTimecodeEventDataWire|HandedEventDataWire|InningEventDataWire|LiveActionEventDataWire|PlayEventDataWire|PositionAssignmentEventDataWire|TeamScoreEventDataWire|null {
  switch(GameEventDataWire[type]) {
    case 'NONE': return null; 
    case 'CountEventDataWire': return accessor(index, new CountEventDataWire())! as CountEventDataWire;
    case 'TeamScoreEventDataWire': return accessor(index, new TeamScoreEventDataWire())! as TeamScoreEventDataWire;
    case 'BattingOrderEventDataWire': return accessor(index, new BattingOrderEventDataWire())! as BattingOrderEventDataWire;
    case 'LiveActionEventDataWire': return accessor(index, new LiveActionEventDataWire())! as LiveActionEventDataWire;
    case 'InningEventDataWire': return accessor(index, new InningEventDataWire())! as InningEventDataWire;
    case 'AtBatEventDataWire': return accessor(index, new AtBatEventDataWire())! as AtBatEventDataWire;
    case 'PlayEventDataWire': return accessor(index, new PlayEventDataWire())! as PlayEventDataWire;
    case 'HandedEventDataWire': return accessor(index, new HandedEventDataWire())! as HandedEventDataWire;
    case 'PositionAssignmentEventDataWire': return accessor(index, new PositionAssignmentEventDataWire())! as PositionAssignmentEventDataWire;
    case 'GumboTimecodeEventDataWire': return accessor(index, new GumboTimecodeEventDataWire())! as GumboTimecodeEventDataWire;
    default: return null;
  }
}
